import React from 'react';
import '../pages/Appointments.css'

const Card = ({ type, time, customer, id, clickHandler, description, phone, done}) => {

  return (
    <div className= {type === "Custom" ? 'tc grow br3 pa2 ma2 dib  shadow-5 bg-light-silver app-card': 
      (type === "Pick Up" ? 'tc grow br3 pa2 ma2 dib bw2 shadow-5 bg-light-purple app-card':
      (type === "First Fitting" ? 'tc grow br3 pa2 ma2 dib bw2 shadow-5 bg-light-blue app-card':
      (type === "Second Fitting" ? 'tc grow br3 pa2 ma2 dib bw2 shadow-5 bg-light-yellow app-card':
      (type === 'Third Fitting' ? 'tc grow br3 pa2 ma2 dib bw2 shadow-5 bg-light-red app-card':
      (type === 'Looking' ? 'tc grow br3 pa2 ma2 dib bw2 shadow-5 bg-light-pink app-card':
      (type === 'Bridal Alterations' ? 'tc grow br3 pa2 ma2 dib bw2 shadow-5 bg-light-green app-card':
      'tc grow br3 pa2 ma2 dib bw2 shadow-5 bg-light-gray app-card'))))))}                           
      onClick={() => clickHandler(id, time, customer, type, description, phone, done )}
    >
      <div style={{ width: "40px", height:"40px"}}>
        {/* <h4>{time}</h4>   */}
        <div className="center fw5">
          {time} 
        </div>
       
      </div>
    </div>
  );
}

export default Card;
